import * as angular from 'angular';
import * as coveragePolicyCardComponent from './coverage-policy-card';
import * as coverageEnhancedCoverageSectionComponent from './coverage-enhanced-coverage-section';
import * as coverageBelongingsSectionComponent from './coverage-belongings-section';
import * as coverageHomeSectionComponent from './coverage-home-section';
import * as coveragePersonalLiabilitySectionComponent from './coverage-personal-liability-section';
import * as coverageMyDeductiblesSectionComponent from './coverage-my-deductibles-section';
import * as coverageSectionListComponent from './coverage-section-list';
import * as coverageScheduledPersonalPropertyComponent from './coverage-scheduled-personal-property-section';
import * as documentDownloadCardComponent from './document-download-card';
import * as coverageEarthquakeCoverageSectionComponent from './coverage-earthquake-coverage-section';
import * as coverageWindCoverageSectionComponent from './coverage-wind-coverage-section';
import * as partnerCoveragePolicyComponent from './partner-coverage-policy';
import * as coverageFloodCoverageSectionComponent from './coverage-flood-coverage-section';

const module = angular.module('coverage-page-components', [
    coveragePolicyCardComponent.module.name,
    coverageEnhancedCoverageSectionComponent.module.name,
    coverageBelongingsSectionComponent.module.name,
    coverageHomeSectionComponent.module.name,
    coveragePersonalLiabilitySectionComponent.module.name,
    coverageMyDeductiblesSectionComponent.module.name,
    coverageSectionListComponent.module.name,
    coverageScheduledPersonalPropertyComponent.module.name,
    documentDownloadCardComponent.module.name,
    coverageEarthquakeCoverageSectionComponent.module.name,
    coverageWindCoverageSectionComponent.module.name,
    partnerCoveragePolicyComponent.module.name,
    coverageFloodCoverageSectionComponent.module.name
]);

export { module };
